export default __webpack_public_path__ + "static/media/Group 3206@2x.9f00a239.png";